/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Delete_Team_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to delete team. Please try again." |
*
* @param {Teams_Delete_Team_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_delete_team_error = /** @type {((inputs?: Teams_Delete_Team_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Delete_Team_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Löschen des Teams. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to delete team. Please try again.")
});